(function () {
  'use strict';

  function onReady(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  }

  function cleanCode(value, requireFrontoPrefix) {
    var code = String(value || '').trim().toUpperCase();
    try { code = decodeURIComponent(code); } catch (error) { /* Use the original scanned text. */ }
    code = code.trim().toUpperCase();
    if (!/^[A-Z0-9-]{4,24}$/.test(code)) return '';
    if (requireFrontoPrefix && code.indexOf('FK') !== 0) return '';
    return code;
  }

  function parseScannedCode(result) {
    var scanned = String(result && result.data ? result.data : result || '').trim();
    if (!scanned) return '';
    try {
      var url = new URL(scanned, window.location.href);
      var queryCode = url.searchParams.get('code') || url.searchParams.get('reward_code') || url.searchParams.get('backup_code');
      if (!queryCode && url.hash) {
        var hashParams = new URLSearchParams(url.hash.replace(/^#/, ''));
        queryCode = hashParams.get('code') || hashParams.get('reward_code') || hashParams.get('backup_code');
      }
      if (queryCode) return cleanCode(queryCode, false);
      var lastSegment = url.pathname.split('/').filter(Boolean).pop();
      if (/redeem|rewards/i.test(url.pathname) && lastSegment) return cleanCode(lastSegment, true);
    } catch (error) {
      // Plain backup codes are handled below.
    }
    return cleanCode(scanned, false);
  }

  function bindScanner(root) {
    var openButton = root.querySelector('[data-frk-scanner-open]');
    var modal = root.querySelector('[data-frk-scanner]');
    var video = root.querySelector('[data-frk-scanner-video]');
    var fileInput = root.querySelector('[data-frk-scanner-file]');
    var codeInput = root.querySelector('[data-frk-form="redeem"] input[name="code"]');
    var redeemMessage = root.querySelector('[data-frk-message="redeem"]');
    var scannerMessage = root.querySelector('[data-frk-scanner-message]');
    if (!openButton || !modal || !video || !fileInput || !codeInput) return;

    var moduleUrl = root.getAttribute('data-frk-scanner-module');
    var scannerModule = null;
    var scanner = null;
    var lastFocus = null;
    var resolved = false;
    var pendingCodeKey = 'hv-rewards-pending-code:fronto-king';

    function setScannerMessage(message, isError) {
      scannerMessage.textContent = message || '';
      scannerMessage.classList.toggle('is-error', Boolean(isError));
    }

    function setRedeemMessage(message, isError) {
      if (!redeemMessage) return;
      redeemMessage.textContent = message || '';
      redeemMessage.classList.toggle('is-error', Boolean(isError));
    }

    async function loadScanner() {
      if (!moduleUrl) throw new Error('QR scanner asset is unavailable.');
      if (!scannerModule) scannerModule = import(new URL(moduleUrl, window.location.href).href);
      var imported = await scannerModule;
      var QrScanner = imported.default;
      if (!QrScanner) throw new Error('QR scanner could not be loaded.');
      return QrScanner;
    }

    function stopScanner() {
      if (!scanner) return;
      try { scanner.destroy(); } catch (error) { /* Camera teardown is best effort. */ }
      scanner = null;
    }

    function closeScanner(restoreFocus) {
      stopScanner();
      modal.hidden = true;
      document.body.classList.remove('frk-scanner-open');
      if (restoreFocus !== false && lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function applyScannedValue(result) {
      if (resolved) return;
      var code = parseScannedCode(result);
      if (!code) {
        setScannerMessage('That QR did not contain a Fronto King reward code. Try again or type the printed backup code.', true);
        return;
      }
      resolved = true;
      codeInput.value = code;
      codeInput.dispatchEvent(new Event('input', { bubbles: true }));
      try { window.sessionStorage.setItem(pendingCodeKey, code); } catch (error) { /* The visible input still holds the code. */ }
      closeScanner(false);
      setRedeemMessage('Code scanned. Review it, then select Check code.', false);
      codeInput.focus();
    }

    async function openScanner() {
      lastFocus = document.activeElement;
      resolved = false;
      modal.hidden = false;
      document.body.classList.add('frk-scanner-open');
      setScannerMessage('Requesting the back camera...', false);
      var closeButton = modal.querySelector('.frk-scanner__close');
      if (closeButton) closeButton.focus();
      if (!window.isSecureContext || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        setScannerMessage('Live camera scanning is not available in this browser. Use Take QR photo or type the backup code.', true);
        return;
      }
      try {
        var QrScanner = await loadScanner();
        scanner = new QrScanner(video, applyScannedValue, {
          preferredCamera: 'environment',
          maxScansPerSecond: 12,
          highlightScanRegion: false,
          highlightCodeOutline: true,
          returnDetailedScanResult: true
        });
        await scanner.start();
        setScannerMessage('Camera ready. Hold the QR inside the gold frame.', false);
      } catch (error) {
        stopScanner();
        var name = error && error.name;
        var denied = name === 'NotAllowedError' || name === 'PermissionDeniedError';
        var missing = name === 'NotFoundError' || name === 'DevicesNotFoundError';
        setScannerMessage(
          denied
            ? 'Camera permission was not approved. Use Take QR photo or type the backup code.'
            : missing
              ? 'No camera was found. Type the printed backup code instead.'
              : 'The camera could not start. Use Take QR photo or type the backup code.',
          true
        );
      }
    }

    openButton.addEventListener('click', openScanner);
    modal.querySelectorAll('[data-frk-scanner-close]').forEach(function (button) {
      button.addEventListener('click', function () { closeScanner(true); });
    });
    fileInput.addEventListener('change', async function () {
      var file = fileInput.files && fileInput.files[0];
      if (!file) return;
      resolved = false;
      setScannerMessage('Reading the QR photo...', false);
      try {
        var QrScanner = await loadScanner();
        var result = await QrScanner.scanImage(file, { returnDetailedScanResult: true });
        applyScannedValue(result);
      } catch (error) {
        setScannerMessage('No readable Fronto King QR was found in that photo. Try again or type the backup code.', true);
      } finally {
        fileInput.value = '';
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeScanner(true);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && !modal.hidden) closeScanner(false);
    });
  }

  if (/127\.0\.0\.1|localhost/.test(window.location.hostname) || new URLSearchParams(window.location.search).has('fk_scanner_qa')) {
    window.FrontoKingRewardsScannerQA = { parseScannedCode: parseScannedCode };
  }

  onReady(function () {
    document.querySelectorAll('[data-frk-root]').forEach(bindScanner);
  });
})();
